var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiemensOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.16 104.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #deddd5;\n        stroke-width: 1px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke: #58595b;\n      }\n\n      .cls-6 {\n        fill: #deddd5;\n      }\n\n      .cls-7 {\n        fill: #0f0f2b;\n      }\n\n      .cls-8 {\n        fill: #808285;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-4 {\n        stroke-width: 1.2px;\n      }\n\n      .cls-5 {\n        stroke-width: 1.3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.4,
    y: 0.4,
    width: 59.36,
    height: 103.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m18.96,38.53c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m27.28,38.53c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m35.6,38.53c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m43.92,38.53c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m32.55,74.88c0,1.72-1.4,3.12-3.12,3.12s-3.12-1.4-3.12-3.12,1.4-3.12,3.12-3.12,3.12,1.4,3.12,3.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.43,
    y1: 47.65,
    x2: 29.43,
    y2: 66.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m34.31,104.22v-1.41c0-.32-.26-.58-.58-.58h-8.6c-.32,0-.58.26-.58.58v1.41h-.84v-1.41c0-.78.64-1.42,1.42-1.42h8.6c.78,0,1.42.63,1.42,1.42v1.41h-.84Zm.95,0v-1.41c0-.84-.69-1.53-1.53-1.53m0,0h-8.6c-.84,0-1.53.69-1.53,1.53v1.41h11.55m-10.49,0v-1.41c0-.26.21-.47.47-.47h8.6c.26,0,.47.21.47.47v1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m36.01,102.28c.06-.45-.14-.93-.5-1.29-.36-.36-.83-.55-1.34-.55l.05-.87c.67.06,1.35.34,1.86.85.5.5.78,1.16.79,1.86h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m34.29,99.69c.67.03,1.29.3,1.76.77.47.48.74,1.1.77,1.76h-.7c-.03-.48-.23-.93-.57-1.27-.34-.34-.79-.54-1.27-.57v-.7Zm-.11-.11v.92c.47,0,.94.18,1.3.54.36.36.54.83.54,1.3h.92c0-.71-.27-1.41-.81-1.95-.54-.54-1.24-.81-1.95-.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m39.7,102.28c.06-1.43-.52-2.83-1.58-3.89-1.05-1.05-2.45-1.63-3.94-1.63l.05-.86c1.66.06,3.26.72,4.46,1.93,1.19,1.19,1.86,2.77,1.87,4.46h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m34.29,96.01c1.65.03,3.2.68,4.36,1.85,1.17,1.17,1.82,2.71,1.85,4.36h-.7c-.03-1.46-.61-2.83-1.65-3.87-1.04-1.04-2.41-1.62-3.87-1.65v-.7Zm-.09-.11h-.02v.92c1.41,0,2.83.54,3.9,1.62,1.08,1.08,1.62,2.49,1.62,3.9h.92c0-1.65-.63-3.3-1.89-4.56-1.25-1.25-2.89-1.88-4.54-1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m37.86,102.28c.06-.94-.33-1.88-1.04-2.59s-1.64-1.09-2.64-1.09l.06-.86c1.16.06,2.3.53,3.16,1.39.85.85,1.32,1.96,1.33,3.16h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m34.29,97.85c1.16.03,2.24.49,3.06,1.31.82.82,1.29,1.91,1.31,3.06h-.7c-.03-.97-.42-1.88-1.11-2.57-.69-.69-1.6-1.08-2.57-1.11v-.7Zm-.11-.11v.92c.94,0,1.88.36,2.6,1.08s1.08,1.66,1.08,2.6h.92c0-1.18-.45-2.35-1.35-3.25s-2.08-1.35-3.25-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m18.96,86.6c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m27.28,86.6c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m35.6,86.6c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m43.92,86.6c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.95,
    y1: 25.25,
    x2: 49.88,
    y2: 25.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.28,
    y: 25.25,
    width: 40.27,
    height: 78.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1.08 .4 9.28 25.25 49.55 25.25 58.97 .4 1.08 .4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m19.48,14.92v-.6c.34.11.65.16.91.16.36,0,.55-.1.55-.29,0-.07-.03-.13-.08-.18-.05-.05-.19-.12-.42-.21-.4-.17-.66-.31-.79-.42-.16-.15-.24-.35-.24-.58,0-.3.12-.53.35-.69.23-.16.52-.23.89-.23.2,0,.49.04.87.11v.58c-.28-.11-.55-.17-.79-.17-.34,0-.51.09-.51.28,0,.07.03.13.1.17.06.04.22.11.47.23.37.16.62.31.74.43.15.14.22.33.22.56,0,.33-.14.58-.43.76-.23.14-.53.21-.9.21-.31,0-.63-.04-.95-.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "22.24 11.92 22.24 11.92 23.1 11.92 23.1 14.97 22.24 14.97 22.24 11.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "23.88 14.97 23.88 11.92 26.06 11.92 26.06 12.47 24.7 12.47 24.7 13.16 25.88 13.16 25.88 13.67 24.7 13.67 24.7 14.39 26.1 14.39 26.1 14.97 23.88 14.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "26.65 14.97 26.65 11.92 27.76 11.92 28.53 13.87 29.31 11.92 30.36 11.92 30.36 14.97 29.55 14.97 29.55 12.81 28.66 15 28.13 15 27.25 12.81 27.25 14.97 26.65 14.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "31.14 14.97 31.14 11.92 33.33 11.92 33.33 12.47 31.96 12.47 31.96 13.16 33.15 13.16 33.15 13.67 31.96 13.67 31.96 14.39 33.36 14.39 33.36 14.97 31.14 14.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "33.92 14.97 33.92 11.92 34.91 11.92 35.96 13.96 35.96 11.92 36.56 11.92 36.56 14.97 35.6 14.97 34.52 12.9 34.52 14.97 33.92 14.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m37.16,14.92v-.6c.34.11.64.16.91.16.36,0,.55-.1.55-.29,0-.07-.03-.13-.08-.18-.05-.05-.19-.12-.42-.21-.4-.16-.66-.31-.79-.42-.16-.15-.24-.35-.24-.58,0-.3.11-.53.34-.69.23-.16.52-.23.89-.23.21,0,.47.03.8.1h.08v.59c-.28-.11-.55-.17-.79-.17-.34,0-.51.09-.51.28,0,.07.03.13.1.17.05.03.21.11.48.23.37.16.62.31.74.43.15.14.22.33.22.56,0,.33-.14.58-.43.76-.24.14-.54.21-.91.21-.31,0-.63-.04-.95-.11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiemensOutline);
export default __webpack_public_path__ + "static/media/SiemensOutline.9856da90626a81d1fd9044419fd41c01.svg";
export { ForwardRef as ReactComponent };